import React, { Component } from "react";
import { View, StyleSheet, ScrollView, Alert,TouchableOpacity,TouchableWithoutFeedback} from "react-native";
//  import { Snackbar, Button } from 'react-native-paper'
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import { isIos, width, isIphoneX } from "../Utils";
// // import { data } from "../../api/questions";
import Button from '@material-ui/core/Button'
import QuestionComponent from './questionComponent';
import Toaster from './../../components/snackBar_toaster';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {selectedAnswers, changeQuestion, submitTest, dispatchClearHomeInfo, clearTest, getAllTestsInfo, timeSpend} from './../../store/action';
// import { } from 'reac-navigation';
// import { resetAll } from './../../navigators/navigationService';
// import Icons from 'react-native-vector-icons/MaterialIcons';
// import { deviceWidth, firebaseLogEvent } from './../Utils';
// import Toast, { DURATION } from 'react-native-easy-toast';
// import Colors from '../Colors';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import GestureRecognizer, {swipeDirections} from './../UI-Components/gestureRecogniseComponent';
import {Text, Styles} from "./../../components/UI-Components"
import { CHALLENGE_TEST } from "../../store/constants";
import Icon from '@material-ui/core/Icon';
import ReorderIcon from '@material-ui/icons/Reorder';
import SelectedScreen from './selectedAnswerScreen';
import SubmitDialog from './submitDialogBox';
import { ActivityIndicator } from "react-native-paper";



class TestAttempt extends Component {
 
  constructor(props) {
    super(props);
    this.state = {
      qNo: 0,
      snackbarMsg: null,
      visible: false, 
      showToast: false,
      toasterMessage: '', 
      showSelectedScreen: false,
      submitDialogOpen: false
    };
  }

  componentWillUnmount() {
    this.props.clearTest();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.submitTestResponse !== this.props.submitTestResponse) {
     
      if(this.props.submitTestResponse) {   
  
        this.showToaster('Test Successfully Submitted')
          const testId = this.props.requestedTestId;
         
          // const attemptingTestId = this.props.attemptingTestId;
          // const testId = null;
          const { state={}} = this.props.location;
          const { isTestSeries, isMaterialTest  } = state;
          // // console.log(testId, attemptingTestId, 'quiz attemting testid', isPlannedTest);
          // const _testId = testId && testId.test_id;
          
          // this.props.navigation.navigate('LeaderBoardForChallengeTests', {
          //   testId:  _testId,
          //   // navigateToHome: true,
          //   // isPlannedTest,
          //   addExtraTime: true,
          //   isAdminTest: isAdminTest
          //   // isTestSeries
          // })

          // if(isPlannedTest) firebaseLogEvent('planned_test_submitted', {});
          // if(isTestSeries) firebaseLogEvent('test_series_test_submitted', {});
        
        
          // if((this.props.testType === CHALLENGE_TEST)) {         
          //   if(isAdminTest) {
          //     // firebaseLogEvent('admin_test_submitted', {});
          //   }else {
          //     // firebaseLogEvent('challenge_test_submitted', {});
          //   }
          //   setTimeout(() => {
          //     this.props.clearTest();
          //     this.props.getAllTestsInfo();
          //     const _testId = testId.test_id
          //     this.props.navigation.push('LeaderBoardForChallengeTests', {
          //       testId:  _testId,
          //       isAdminTest: isAdminTest,
          //       addExtraTime: true,                
          //     })
          //   }, 800);
          //   return;
          // }
          
          if(testId) {
            setTimeout(() => {
              this.props.clearTest();
              this.props.getAllTestsInfo();
              this.props.history.push('/ShowResults', {
                testId:  testId,
                navigateToHome: true,
                isPlannedTest: false,
                addExtraTime: true,
                isTestSeries,
                isMaterialTest
              })
            }, 800);
          }else{          
            this.props.dispatchClearHomeInfo();
            setTimeout(() => {
              // resetAll(this.props.navigation, 'Home');
              this.props.history.push('/Home')
            }, 800);
        }
      }
    }

    if(prevProps.submitTestError !== this.props.submitTestError) {
      if(this.props.submitTestError) {
        const errorMessage = this.props.submitTestErrInfo || 'some thing went wrong'; 
        this.showToaster(errorMessage)
        setTimeout(() => {
          this.props.history.push('/Home')
        }, 2000)
      }
    }
    if(prevProps.submitTestLoading !== this.props.submitTestLoading){
      if(this.props.submitTestLoading){
        this.setState({
          submitDialogOpen: false
        })
      }
    }
  }

  

  // submitData = () => {
  //   const { testAllQuestions, answers, totalQuestions, requestedTestId} = this.props; 
  //   let userSelectedAnswers = [];
  //   let isSubmit = false; 

   
  //   testAllQuestions.map(question => {
  //     let isAnswered = false;
  //     answers.map(answer => {
  //       if (question.id === answer.id) {
  //         isAnswered = true;
  //         userSelectedAnswers.push(answer);
  //         return;
  //       };
  //     })

  //     //set null for un attempted questions
  //     // if (!isAnswered) {
  //     //   const notAnswered = {
  //     //     id: question.id,
  //     //     answer_option: null,
  //     //     status: "1"
  //     //   }
  //     //   userSelectedAnswers.push(notAnswered);
  //     // }
  //   })

  //   const userSubmitData = {
  //     test_id: requestedTestId,
  //     user_id: 10,
  //     questions: userSelectedAnswers
  //   }
  //   console.log(userSubmitData, 'submit data');
  //   this.props.submitTest(userSubmitData);
  // }
//   onSwipeLeft = (gestureState) => {
//     // this.setState({myText: 'You swiped left!'});
//     alert('')
//   }
 
// onSwipeRight = (gestureState) => {
//     alert('')
//     this.setState({myText: 'You swiped right!'});
//   }
showToaster = (msg) => {
  this.setState({
    showToast: true,
    toasterMessage: msg
  })
}

  render() {     
    const config = {
      velocityThreshold: 0.3,
      directionalOffsetThreshold: 80
    };
    // const isPlannedTest = this.props.navigation.getParam('plannedTest', false);    
    // const isTestSeries = this.props.navigation.getParam('isTestSeries', false);   
    // const { state={}} = this.props.location;
    // const { isTestSeries  } = this.state;
    // const {
    //   isPlannedTest,
    //   isTestSeries,
    //   isAdminTest,
    //   isMaterialTest
    // } = this.props?.route?.params;
    const { state={}} = this.props.location;
          const { isTestSeries, isMaterialTest  } = state;
   
    const { qNo, snackbarMsg, visible } = this.state;
    const { data, selectedAnswers, answers, changeQuestion, 
      activeQuestion, totalQuestions, submitTestResponse,
       submitTestLoading, passages } = this.props;
    const presentQuestion = data[activeQuestion];
    return (
      <>
       <View style={{flex:1,marginHorizontal:10}}>
          <View style={{flex:1, }}>
            <QuestionComponent 
              data={data[activeQuestion]} 
              checkedAnswers={selectedAnswers}
              answers={answers}
              qNo={activeQuestion}
              passages={passages}
              navigation={this.props.navigation}
            />
        </View>
        <div style={{width: '100%', position: 'absolute', bottom: 5,}}> 

        {/* {
          (activeQuestion >= totalQuestions-1) 
            ?
           
            <View style={{ width: '100%', justifyContent:'flex-end',alignItems:'center',}}>
              <Button
                variant="outlined"
                disabled={submitTestLoading || submitTestResponse ? true : false}
                startIcon={submitTestLoading || submitTestResponse  ? <ActivityIndicator size="small"/>: false}
                style={{justifyContent:'center',
                 alignItems:'center', marginBottom: 10,
                 borderRadius:20,backgroundColor: Styles.primaryColor,
                 color: '#fff'
                }}
                onClick={() => {                
              if(answers.length <= totalQuestions){
                this.setState({
                  submitDialogOpen: true
                })
             
              }                
              // this.props.history.push('/ShowResults')
              } 
            }
            >
            SUBMIT
            </Button>
              </View>
          : null    
        } */}
        <View style={styles.bottom}>
         {
           !(activeQuestion <= 0) ?
            <TouchableOpacity
          style={{
            backgroundColor:'#679D81',
            paddingBottom:0,width:'42%',height:40,paddingHorizontal:0,color:'#fff',textAlign:'center',justifyContent:'center',
            alignItems:'center',
            marginLeft: -10,
            marginTop: 20,
            borderBottomLeftRadius: 10
          }}
          onPress={() => changeQuestion(activeQuestion-1,  presentQuestion?.id)} 
            color={"red"} 
            // disabled={activeQuestion <= 0}
          >
          <Text style={{color:'#fff', fontWeight: 'bold'}}>PREVIOUS</Text>
          </TouchableOpacity>
          : (
              <View style={{width:'40%'}}>
                  {/* <Text>askjdhfj</Text> */}
              </View>
          ) 
        }
      


         
          {
          !(activeQuestion >= totalQuestions-1) ?
            <TouchableOpacity
              style={{
                backgroundColor:'#3758DB',
                paddingBottom:0,
                width:'42%',
                height:40,
                paddingHorizontal:10, 
                color:'#fff',
                justifyContent:'center',
                alignItems:'center',
                marginRight: -10,
                marginTop: 20,
                borderBottomRightRadius: 10
            
            }}
              onPress={() => changeQuestion(activeQuestion+1, presentQuestion?.id)}
              disabled={activeQuestion >= totalQuestions-1}
            >
            <Text style={{color:'#fff', fontWeight: 'bold'}}>NEXT</Text>
            </TouchableOpacity>
            : 
            <View style={{width: '42%',}}>
            <Button
              variant="outlined"
              disabled={submitTestLoading || submitTestResponse ? true : false}
              startIcon={submitTestLoading || submitTestResponse  ? <ActivityIndicator size="small"/>: false}
              style={{
              backgroundColor:'#0c9500',
                paddingBottom:0,width:'100%',height:40,
                paddingHorizontal:0,
                color:'#fff',textAlign:'center',justifyContent:'center',
              alignItems:'center',
                marginLeft: -10,
                marginTop: 20,
                borderBottomLeftRadius: 10
              }}
              onClick={() => {                
            if(answers.length <= totalQuestions){
              this.setState({
                submitDialogOpen: true
              })
           
            }                
            // this.props.history.push('/ShowResults')
            } 
          }
          >
          SUBMIT
          </Button>
            </View>
          }
        </View>
        </div>

            {/* <Snackbar
                style={{backgroundColor:'#fff',color:'#222', width: '96%'}}
                visible={visible}
                onDismiss={() => this.setState({ visible: false })}
                action={{
                    label: 'close',
                    onPress: () => {
                        this.setState({ visible: false })
                    },
                }}
                >
                <Text style={{color:'red'}}>
                {snackbarMsg}
                </Text>
            </Snackbar> */}
            {/* <Toast
                  position={'bottom'}
                  positionValue={180}
                  opacity={1}
                  textStyle={{ color: Colors.toastTextColor }}
                  style={{
                    marginBottom: 50,
                    backgroundColor: Colors.toastBgColor,
                    paddingHorizontal: Colors.toastPaddingHorizontal,
                    borderRadius: 20,
                  }}
                  ref="toast" /> */}
              <Toaster 
                    show={this.state.showToast}
                    message={this.state.toasterMessage}
                    handleClose={() => this.setState({
                      showToast: false
                    })}
                    
                    />
      </View>
      {
        this.state.showSelectedScreen ?
         <SelectedScreen
           open={this.state.showSelectedScreen}
           activeQuestionId={presentQuestion?.id}
           handleClose={() => this.setState({showSelectedScreen: false })}
         />
         : null
      }
      {
        this.state.submitDialogOpen ?
        <SubmitDialog
         open={this.state.submitDialogOpen}
         handleClose={
           () => this.setState({
            submitDialogOpen: false
           })
         }

         handleSubmitTest={() =>{
          const {state}= this.props.location || {};
          const { plannedTest=false, isTestSeries, isMaterialTest } = state || {}
          this.props.timeSpend(presentQuestion?.id);
          setTimeout(() => {
                         
            this.props.submitTest(false, isTestSeries, isMaterialTest)
          }, 800);          
          
          }
         }
        />
        : null
      }
      </>
    );
  }
}

// const bttomVal = isIphoneX() ? 70 : 0;

const styles = StyleSheet.create({
  buttons: {
    // paddingHorizontal: 8,
    // paddingVertical: 16,
    // margin: 4,
    // borderWidth: 1,
    // borderRadius:4,
    // backgroundColor:'red'
  },
  bottom: {
    // borderWidth:1,
    // width: deviceWidth-30,
    // paddingVertical: 20,
    justifyContent: "space-between",
    flexDirection: "row",
  }
});

const mapStateToProps = state => {

  return {
    testInfo: state.testInfo && state.testInfo,
    testAllQuestions: state.testInfo && state.testInfo.test && state.testInfo.test,
    answers: state.testInfo.selectedAnswers || [],
    activeQuestion:state.testInfo && state.testInfo.activeQuestion,
    totalQuestions: state.testInfo && state.testInfo.test.length,
    passages: state.testInfo && state.testInfo.passages,  
    requestedTestId: state.testInfo && state.testInfo.requestedTestId && state.testInfo.requestedTestId,
    attemptingTestId: state.testInfo && state.testInfo.testId,
    submitTestLoading: state.submitTest && state.submitTest.loading && state.submitTest.loading,
    submitTestError: state.submitTest && state.submitTest.error && state.submitTest.error,
    submitTestErrInfo: state.submitTest && state.submitTest.errInfo && state.submitTest.errInfo.data && state.submitTest.errInfo.data.message,
    submitTestResponse: state.submitTest && state.submitTest.response && state.submitTest.response, 
    testType: state.testInfo && state.testInfo.totalResponse && state.testInfo.totalResponse.test_type
  }
}


export default connect(mapStateToProps, {selectedAnswers, changeQuestion, submitTest, dispatchClearHomeInfo, clearTest, getAllTestsInfo,timeSpend})(withRouter(TestAttempt));
